export default [
    'Name', 
    'Required', 
    'Description', 
    'Example'
];